export default {
  "title1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["나의"])},
  "title2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["업무 성격은?"])},
  "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["By Asiance"])},
  "start_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["시작하기"])},
  "intro_text1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["월요일 아침이 밝았다..."])},
  "intro_text2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["정신차리고 일어나! 일하러 가야지!"])},
  "tutorial": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["양 옆으로 밀어서 옵션을 확인하세요. 탭하여 선택하세요."])}
}